module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABJUlEQVQ4T2NkwAE0ZxiFMzIyGlxLP1uJTQkjLo1as4wSGP8z6V9NP1M4HDRqTzex/v/v28Vr2de+wPyDzY9aq7TYGN9zWl9NP7sfHDjaM01a/jMy2LB8/OV9qfTSV5AYukbjmcasPxgZVjIwMLy7mnY2BR6q2rNMJv9nYNCFaUbWCNf0n/HXVcEz0QxhDH9RokN7lvHU/4yM6p8+v/Dl4xELB0eH4JkSrffGy0GuuCZ4NhKkCcRGjcf/DIzas41nMjAyKPz7x7CekZFRk/E/gxgD4382jv8M4WfTz/6GhQFmAoBpZmDwZ2Bg4GJgYNiNrgnTRphxDQxM2tJGmQz/GFj/C/6Ydi3s2i/01IMzyeFKinCnas8yefyfgUGEkEJkeUYGhjcAqXuA60mQ/G4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/caigou/xiaicon.png
// module id = 6++V
// module chunks = 4